import { FC, useContext, useEffect } from 'react';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';
import { CoveragesFireSection } from '../CoverageFireSection';

import { StepThreeFormContext } from '../../../StepThree/contexts/StepThreeForm';
import { StepFourFormContext } from '../../contexts/StepFourForm';

interface FireQuotationFormByTabProps {
  tabKey: number;
}

export const FireQuotationFormByTab: FC<FireQuotationFormByTabProps> = ({
  tabKey,
}) => {
  const { plansByActivityList, stepThreeForm } =
    useContext(StepThreeFormContext);
  const { stepFourFireQuotationForm } = useContext(StepFourFormContext);

  const planSelected = stepThreeForm?.getFieldValue(`plan-tab-${tabKey}`);

  useEffect(() => {
    if (planSelected) {
      stepFourFireQuotationForm.setFieldValue(
        `plan-tab-${tabKey}`,
        planSelected
      );
    }
  }, [planSelected, stepFourFireQuotationForm, tabKey]);

  return (
    <>
      <ContentSection level='h3' title='Planes'>
        <RowSize>
          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: 'Lista de Planes:',
                name: `plan-tab-${tabKey}`,
              }}
              selectProps={{
                disabled: true,
                options: plansByActivityList,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>

      <CoveragesFireSection tabKey={tabKey} />
    </>
  );
};
